import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { Button } from "./Button";

export function CartSummary() {
  const { total } = useCart();

  const tax = total * 0.08; // 8% tax
  const shipping = 10.0; // Flat rate shipping
  const finalTotal = total + tax + shipping;

  return (
    <div className="bg-gray-50 p-6 rounded-lg">
      <h2 className="text-xl font-bold mb-4">Order Summary</h2>
      <div className="space-y-2 mb-4">
        <div className="flex justify-between">
          <span>Subtotal</span>
          <span>${total.toFixed(2)}</span>
        </div>
        <div className="flex justify-between">
          <span>Tax (8%)</span>
          <span>${tax.toFixed(2)}</span>
        </div>
        <div className="flex justify-between">
          <span>Shipping</span>
          <span>${shipping.toFixed(2)}</span>
        </div>
        <div className="border-t pt-2 flex justify-between font-bold text-lg">
          <span>Total</span>
          <span>${finalTotal.toFixed(2)}</span>
        </div>
      </div>
      <Link to="/checkout">
        <Button variant="primary" className="w-full">
          Proceed to Checkout
        </Button>
      </Link>
    </div>
  );
}
